export default function replaceCharactersWithX(number: number | string) {
  const DIGIT_REGEX = /\d/g;
  const UPPER_CASE_ALPHABET_REGEX = /[A-Z]/g;
  const LOWER_CASE_ALPHABET_REGEX = /[a-z]/g;
  return number
    .toString()
    .replace(DIGIT_REGEX, 'X')
    .replace(UPPER_CASE_ALPHABET_REGEX, 'X')
    .replace(LOWER_CASE_ALPHABET_REGEX, 'x');
}
